import { useDispatch, useSelector } from 'react-redux';
import { useKeyboard } from '../../../shared/hooks/useKeyboard';
import { useWindowListener } from '../../../shared/hooks/useWindowListener';
import { stopRuler } from '../../ruler/thunks/stop-ruler.thunk';
import * as beatsActions from '../../beats/beats.actions';
import { projectedBaseClusterSelector } from '../selectors/cluster.selectors';
import { selectBaseClusters } from '../thunks/select-base-clusters.thunk';

export const useClusterListener = () => {
  const dispatch = useDispatch();
  const projectedCluster = useSelector(projectedBaseClusterSelector);

  useKeyboard('keydown', 'Escape', () => {
    dispatch(beatsActions.select({ ids: new Set() }));
    if (projectedCluster != null) {
      dispatch(selectBaseClusters(projectedCluster));
    }
  });

  /*
   * Ruler listener
   * When the user releases the mouse, we stop updating the ruler's position
   */
  useWindowListener('mouseup', () => {
    dispatch(stopRuler());
  });
};
